import { useState, useMemo, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface UseActiveLink {
  activeLink: string;
  handleActiveLink: (label: string, match: unknown) => boolean;
}

const useActiveLink = (profileType?: ProfileType): UseActiveLink => {
  const [activeLink, setActiveLink] = useState('');
  const { pathname } = useLocation();
  const { currentProfile } = useSelector((state: RootState) => state.user);
  const activeLinkRef = useRef('');

  const handleActiveLink = (label: string, match: unknown): boolean => {
    if (match && (profileType === currentProfile?.type || !profileType)) {
      activeLinkRef.current = label;
      return true;
    }
    return false;
  };

  useMemo(() => {
    activeLinkRef.current = '';
  }, [pathname, currentProfile?.type]);

  useEffect(() => {
    setActiveLink(activeLinkRef.current);
  }, [pathname, currentProfile?.type]);

  return {
    activeLink,
    handleActiveLink,
  };
};

export default useActiveLink;
